<div>
  <div *ngIf="submitted">
    <p>
      Sie erhalten in Kürze einen Link zum Zurücksetzen des Passworts per
      E-Mail.
    </p>
  </div>
  <div *ngIf="!submitted">
    <input
      type="email"
      autocomplete="off"
      [(ngModel)]="email"
      #emailInput="ngModel"
      name="emailInput"
      id="emailInput"
      class="form-control"
      placeholder="E-Mail"
      pattern="[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+"
      (keydown.enter)="FormAutomation.FocusNextChild($event)"
      @inOutAnimation
    />

    <div *ngIf="!isConnected">
      <p>
        Der Schulio-Server ist nicht erreichbar. Bitte überprüfen Sie Ihre
        Internet&shy;verbindung.
      </p>
    </div>

    <button
      id="submit"
      class="btn btn-block form-control"
      [disabled]="emailInput.invalid || email.length == 0 || !isConnected"
      @inAnimation
      (click)="resetPassword()"
    >
      Passwort zurücksetzen
    </button>
  </div>
</div>
